(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4268],{

/***/ 681:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[hid]/facilities",
      function () {
        return __webpack_require__(3520);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3520:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ FacilityPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8029);
/* harmony import */ var interweave__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9996);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7294);
/* harmony import */ var _containers_Helmet__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9536);
/* harmony import */ var _layout_FooterHotel__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8078);
/* harmony import */ var _layout_HeaderV3__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4850);
/* harmony import */ var _layout_Section__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1914);
/* harmony import */ var _utils_functions__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9735);












var __N_SSG = true;
function FacilityPage(param1) {
    var header = param1.header, hotelBrands = param1.hotelBrands;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)().locale;
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        var temp = header.hotel_facilities;
        var a = (0,_utils_functions__WEBPACK_IMPORTED_MODULE_11__/* .objParserWP */ .aG)(temp, "item");
        var b = (0,_utils_functions__WEBPACK_IMPORTED_MODULE_11__/* .objParserWPLv2 */ .iZ)(temp, "item");
        var c = (0,_utils_functions__WEBPACK_IMPORTED_MODULE_11__/* .objParserWPLv3 */ .nz)(temp, "item");
        var d = (0,_utils_functions__WEBPACK_IMPORTED_MODULE_11__/* .objParserWPLv4 */ .yN)(temp, "item");
        var final = a.map(function(v, i) {
            return {
                thumb: v,
                name: b[i],
                desc: c[i],
                desc_custom: d[i]
            };
        });
        setItems(final);
    }, []);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(), items = ref[0], setItems = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), isPop1 = ref1[0], setIsPop = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(0), itemIdx = ref2[0], setItemIdx = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        if (isPop1) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }
    }, [
        isPop1
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_Helmet__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                title: "Facility - ".concat(header.name, " | Parador Hotels & Resorts")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_HeaderV3__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                headerItem: header,
                isHomepage: false,
                hotelBrands: hotelBrands
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_Section__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Center */ .M5Y, {
                        flexDir: "column",
                        alignItems: "center",
                        mb: 10,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6q, {
                                mb: 3,
                                as: "h1",
                                fontWeight: 400,
                                letterSpacing: "wider",
                                color: header.color_primary,
                                textAlign: "center",
                                children: locale == "id" ? "FASILITAS" : "FACILITIES"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                maxW: {
                                    base: "90%",
                                    md: "50%"
                                },
                                align: "center",
                                children: locale == "id" ? "Nikmati pengalaman menginap ala selebriti dengan kamar modern dan fasilitas yang nyaman" : "Enjoy a celebrity-style stay with modern facilities and comfortable rooms"
                            })
                        ]
                    }),
                    items && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .SimpleGrid */ .MIq, {
                        columns: {
                            base: 1,
                            md: 2,
                            lg: 3
                        },
                        columnGap: 6,
                        rowGap: 12,
                        children: items.map(function(param, i) {
                            var desc = param.desc, name = param.name, thumb = param.thumb;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                flexDir: "column",
                                gap: 3,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                                        h: [
                                            "30vh",
                                            "42vh"
                                        ],
                                        w: "100%",
                                        position: "relative",
                                        cursor: "pointer",
                                        onClick: function() {
                                            setItemIdx(i);
                                            setIsPop(true);
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                            layout: "fill",
                                            src: thumb,
                                            alt: name,
                                            objectFit: "cover",
                                            priority: true,
                                            unoptimized: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6q, {
                                        as: "h2",
                                        fontWeight: 400,
                                        fontSize: "lg",
                                        letterSpacing: 4,
                                        color: "black",
                                        mt: 3,
                                        noOfLines: 1,
                                        children: name
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                        fontSize: "sm",
                                        letterSpacing: 0.2,
                                        lineHeight: 1.2,
                                        noOfLines: 2,
                                        children: desc
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zxk, {
                                            bg: "transparent",
                                            color: header.color_primary,
                                            variant: "outline",
                                            borderColor: header.color_primary,
                                            _hover: {
                                                bg: header.color_primary,
                                                color: "white"
                                            },
                                            onClick: function() {
                                                setItemIdx(i);
                                                setIsPop(true);
                                            },
                                            children: locale == "id" ? "Lihat Lagi" : "See More"
                                        })
                                    })
                                ]
                            }, name);
                        })
                    })
                ]
            }),
            isPop1 && items && items.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FacilityPop, {
                color: header.color_primary,
                title: items[itemIdx].name,
                img: items[itemIdx].thumb,
                desc: items[itemIdx].desc,
                customDesc: items[itemIdx].desc_custom,
                button: function(isPop) {
                    return setIsPop(isPop);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                h: 10
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_FooterHotel__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                instagram: header.instagram,
                facebook: header.facebook,
                locationLink: header.location_url,
                location: header.location_long,
                email: header.email,
                phone: header.phone,
                bg: header.color_primary,
                color: "white",
                logo: header.logo_light,
                hotelSlug: header.slug
            })
        ]
    });
};
function FacilityPop(param) {
    var color = param.color, title = param.title, img = param.img, desc = param.desc, customDesc = param.customDesc, button = param.button;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)().locale;
    var popRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .useOutsideClick */ .O3d)({
        ref: popRef,
        handler: function() {
            return button(false);
        }
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
        position: "fixed",
        top: 0,
        zIndex: 5,
        bg: "blackAlpha.600",
        h: "100vh",
        w: "100vw",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .AbsoluteCenter */ .umj, {
            w: [
                "90vw",
                "70vw"
            ],
            h: [
                "80vh"
            ],
            overflowY: "scroll",
            // h="100%"
            mt: 8,
            bg: "white",
            py: 8,
            px: [
                4,
                10,
                24
            ],
            zIndex: 6,
            ref: popRef,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6q, {
                    mb: 10,
                    as: "h2",
                    fontWeight: 400,
                    letterSpacing: "wider",
                    color: color,
                    textAlign: "center",
                    children: title !== null && title !== void 0 ? title : ""
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                    w: "100%",
                    h: [
                        "40vh",
                        "50vh"
                    ],
                    position: "relative",
                    mb: 6,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                        src: img,
                        alt: title + " Image",
                        layout: "fill",
                        objectFit: "cover",
                        priority: true,
                        unoptimized: true
                    })
                }),
                (0,lodash__WEBPACK_IMPORTED_MODULE_3__.isEmpty)(customDesc) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Center */ .M5Y, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                        textAlign: "center",
                        color: "blackAlpha.700",
                        w: [
                            "90%",
                            "70%",
                            "50%"
                        ],
                        children: desc
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                    maxW: "full",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(interweave__WEBPACK_IMPORTED_MODULE_2__/* .Markup */ .Lu, {
                        className: "white-space-enter",
                        content: customDesc.replace(/\\n/g, "<br>")
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Center */ .M5Y, {
                    my: 10,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zxk, {
                        bg: color,
                        color: "white",
                        variant: "solid",
                        px: 8,
                        _hover: {
                            variant: "outline",
                            bg: "transparent",
                            border: "1px solid ".concat(color),
                            color: color
                        },
                        onClick: function() {
                            button(false);
                        },
                        children: locale == "id" ? "TUTUP" : "CLOSE"
                    })
                })
            ]
        })
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,5525,9996,4939,8078,9774,2888,179], function() { return __webpack_exec__(681); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);